import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { bigdecimal } from '@logio/big-decimal';
import { DateParser, BigNumberParser, OptionalDesc, Utils } from '@logio/common-be-fe';
import moment from 'moment';
export var ChartGenerator =
/*#__PURE__*/
function () {
  function ChartGenerator(schema) {
    _classCallCheck(this, ChartGenerator);

    this.schema = schema;
  }

  _createClass(ChartGenerator, [{
    key: "getSeries",
    value: function getSeries(data, xAxis, yAxis, zAxis, sort) {
      var _this = this;

      if (!Utils.isValueMissing(data)) {
        if (!this.schema.hasOwnProperty(xAxis)) {
          throw new Error("Property ".concat(xAxis, " does not exists in data description"));
        }

        if (yAxis && !this.schema.hasOwnProperty(yAxis)) {
          throw new Error("Property ".concat(yAxis, " does not exists in data description"));
        }

        if (zAxis && !this.schema.hasOwnProperty(zAxis)) {
          throw new Error("Property ".concat(zAxis, " does not exists in data description"));
        }

        return this.sortData(data, sort || xAxis).map(function (item) {
          if (zAxis) {
            return [_this.parseData(item, xAxis), _this.parseData(item, yAxis), _this.parseData(item, zAxis)];
          } else if (yAxis) {
            return [_this.parseData(item, xAxis), _this.parseData(item, yAxis)];
          } else {
            return _this.parseData(item, xAxis);
          }
        });
      }

      return [];
    }
  }, {
    key: "parseData",
    value: function parseData(data, key) {
      var propDescBase = this.getDescBase(key);

      switch (propDescBase.parser.constructor.name) {
        case BigNumberParser.name:
          return bigdecimal(data[key]);

        case DateParser.name:
          return data[key].toDate().getTime();

        default:
          return data[key];
      }
    }
  }, {
    key: "getDescBase",
    value: function getDescBase(key) {
      var propDescBase;

      if (this.schema[key] instanceof OptionalDesc) {
        propDescBase = this.schema[key].base;
      } else {
        propDescBase = this.schema[key];
      }

      return propDescBase;
    }
  }, {
    key: "sortData",
    value: function sortData(data, key) {
      var propDescBase = this.getDescBase(key);

      if (!Utils.isValueMissing(data)) {
        switch (propDescBase.parser.constructor.name) {
          case DateParser.name:
            return data.sort(function (a, b) {
              return moment(a[key]).isAfter(b[key]) ? 1 : moment(a[key]).isBefore(b[key]) ? -1 : 0;
            });

          default:
            return data.sort(function (a, b) {
              return a[key] > b[key] ? 1 : a[key] < b[key] ? -1 : 0;
            });
        }
      }

      return [];
    }
  }]);

  return ChartGenerator;
}();